export default "__VITE_ASSET__bfca3ee0__"